/**
 * Confirmation before selecting a single organization event, which may be exclusive
 * to that organization.
 */

import React from 'react';
import { Button, Modal } from 'semantic-ui-react';
import { I18n, Translate } from 'react-redux-i18n';
import { i18nKeys } from '../constants';
import { OrganizationEvent } from '../types';

interface ExclusiveEventModalProps {
  event: OrganizationEvent | null;
  onConfirm: (event: OrganizationEvent) => void;
  onCancel: () => void;
}

const ExclusiveEventModal: React.FC<ExclusiveEventModalProps> = ({
  event,
  onConfirm,
  onCancel
}) => (
  <Modal
    className="wizard"
    size="small"
    dimmer="inverted"
    closeIcon
    open={event !== null}
    onClose={onCancel}
  >
    <Modal.Header>
      <h3>
        <Translate value={i18nKeys.EXCLUSIVE_MODAL.TITLE} />
      </h3>
    </Modal.Header>
    <Modal.Content>
      <p>
        {I18n.t(i18nKeys.EXCLUSIVE_MODAL.BODY, { name: event?.name ?? '' })}
      </p>
      <p>
        <Translate value={i18nKeys.EXCLUSIVE_MODAL.QUESTION} />
      </p>
      <div className="button-wrapper align-right" style={{ marginTop: '16px' }}>
        <Button onClick={onCancel}>
          <Translate value={i18nKeys.EXCLUSIVE_MODAL.CANCEL} />
        </Button>
        <Button color="orange" onClick={() => event && onConfirm(event)}>
          <Translate value={i18nKeys.EXCLUSIVE_MODAL.CONFIRM} />
        </Button>
      </div>
    </Modal.Content>
  </Modal>
);

export default ExclusiveEventModal;
